module.exports = __webpack_public_path__ + "static/media/location-active.f9110e9c.svg";